/**
 * Aldoo Snap — project-specific signin error handling.
 * Hooked by aldoo-ra/Signin/signin-controller (see projectHandleSigninError).
 * Return true when the error is handled here.
 */
export default function handleSigninError({
  error,
  texts,
  navigate,
  showPromptDialog,
  done,
}) {
  // All seats taken: signing in on this Mac can't activate it — offer the
  // pricing page instead of a dead-end OK.
  if (error === "seat_limit_reached") {
    showPromptDialog({
      title: texts?.error_dialog_title,
      message:
        "All license seats are in use. Free a seat from your license management page or get more seats.",
      yesLabel: "Get more seats",
      noLabel: "Close",
      onConfirm: () => {
        done()
        // Inside the mac app's sign-in WebView, hand off to the app — it
        // opens the system browser at /pricing (with an OTP login when a
        // session exists). Regular browsers just navigate.
        const appHandler = window.webkit?.messageHandlers?.aldooSnap
        if (appHandler) {
          appHandler.postMessage(JSON.stringify({ action: "open_pricing" }))
          return
        }
        navigate("/pricing")
      },
      onCancel: done,
    })
    return true
  }

  return false
}
